export default __webpack_public_path__ + "static/media/icon-20-icn-poi-departure.93643a69.svg";